export default "__VITE_ASSET__08a1c2e5__"